import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'rowCheckbox',
    'selectAll',
    'table'
  ]

  selectAllVisible(evt) {
    for (const c of this.rowCheckboxTargets) {
      if (c.offsetParent !== null) { // Check if element is visible
        c.checked = true;
      }
    }
  }

  deselectAll(evt) {
    for (const c of this.rowCheckboxTargets) {
      c.checked = false;
    }
  }
}